import React, { useEffect, useState } from "react";
import "./QuestionWisePage.css";
import QuestionGridNumber from "../../components/QuestionWise/QuestionGridNumber";
import QuestionText from "../../components/QuestionWise/QuestionText";
import useAppHooks from "../../../../shared/hooks/useAppHooks";

import {
  fetchPracticeSolutionRequest,
  fetchQuestionAnalyticsRequest,
} from "../../../../redux/exam_analytics/analyticsSlice";

import Modal from "../../../../shared/components/Modal/Modal";
import { ClipLoader } from "react-spinners";
import ScoreBar from "../../../../shared/components/ScoreBar/ScoreBar";

export default function QuestionWisePage() {
  const { dispatch, selector } = useAppHooks();

  const { practiceSolution, questionAnalytics, loading, error } = selector(
    (s) => s.analyticsSlice
  );

  const practiceLoading = loading?.practice || false;
  const practiceError = error?.practice || null;
  const qLoading = loading?.question || false;

  const data = practiceSolution?.data || [];

  const [selectedIndex, setSelectedIndex] = useState(0);
  const [isAnalyticsOpen, setIsAnalyticsOpen] = useState(false);

  useEffect(() => {
    dispatch(
      fetchPracticeSolutionRequest({
        paperId: 12370,
        testId: 198,
        paperType: 3,
      })
    );
  }, [dispatch]);

  const handleNext = () => {
    setSelectedIndex((prev) => (prev < data.length - 1 ? prev + 1 : prev));
  };

  const handlePrev = () => {
    setSelectedIndex((prev) => (prev > 0 ? prev - 1 : prev));
  };

  const handleAnalysis = () => {
    const qid = data[selectedIndex]?.qid;
    if (qid) {
      dispatch(
        fetchQuestionAnalyticsRequest({
          paperId: 12370,
          paperType: 3,
          qid,
        })
      );
      setIsAnalyticsOpen(true);
    }
  };

  const closeAnalyticsModal = () => setIsAnalyticsOpen(false);

  if (practiceLoading) {
    return (
      <div className="questionPage_loading">
        <ClipLoader color="#C61C26" size={50} />
      </div>
    );
  }

  if (practiceError) {
    return (
      <div className="questionPage_error">
        <p>Error: {practiceError}</p>
      </div>
    );
  }

  if (!data.length) {
    return (
      <div className="questionPage_empty">
        <p>No question data available.</p>
      </div>
    );
  }

  // Format seconds into mm:ss
  const formatTime = (s) => {
    if (!s || s === "null") return "--";
    const sec = parseInt(s, 10);
    const m = Math.floor(sec / 60)
      .toString()
      .padStart(1, "0");
    const ss = (sec % 60).toString().padStart(2, "0");
    return `${m}:${ss}`;
  };

  return (
    <div className="questionPage_wrapper">
      <div className="questionPage_left">
        <QuestionText data={data[selectedIndex]} />
      </div>

      <div className="questionPage_right">
        <QuestionGridNumber
          selectedIndex={selectedIndex}
          onSelect={setSelectedIndex}
        />
      </div>

      <div className="bottom_nav_buttons">
        <div className="nav_btn_group">
          <button
            className="nav_btn"
            onClick={handlePrev}
            disabled={selectedIndex === 0}
          >
            Previous
          </button>

          <button
            className="nav_btn"
            onClick={handleNext}
            disabled={selectedIndex === data.length - 1}
          >
            Next
          </button>
        </div>

        <button className="nav_btn analysis_btn" onClick={handleAnalysis}>
          Analytics
        </button>
      </div>

      {/* MODAL */}
      <Modal
        isOpen={isAnalyticsOpen}
        onClose={closeAnalyticsModal}
        width="727px"
        height="678px"
        backgroundColor="#fff"
        borderRadius="1rem"
      >
{qLoading ? (
  <div className="questionPage_loading">
    <ClipLoader color="#0066FF" size={45} />
  </div>
) : questionAnalytics ? (
  <div className="qa_modal_wrapper">

<h2 className="qa_title">Question Analysis</h2>

<div className="qa_header_block">
  <div className="qa_header_text">
    <p className="qa_subject">{questionAnalytics.subject}</p>
    <p className="qa_topic">{questionAnalytics.topic}</p>
  </div>

  <div className="qa_tags">
    <span className="qa_tag_easy">{questionAnalytics.toughness}</span>
    <span className="qa_tag_correct">
      {questionAnalytics.your_answer ? "Correct" : "Unanswered"}
    </span>
  </div>
</div>


    <h3 className="qa_stats_heading">Student Performance Statistics</h3>

    <div className="qa_stats_box">

      {/* Correct */}
      <div className="qa_stat_column">
        <ScoreBar
          label="Correct"
          score={(questionAnalytics.correct_students / questionAnalytics.total_students) * 100}
          color="#16A34A"
          subLabel=""
          metricType="accuracy"
          totalPossible={100}
        />
        <p className="qa_students">
          {questionAnalytics.correct_students} Students
        </p>
      </div>

      {/* Incorrect */}
      <div className="qa_stat_column">
        <ScoreBar
          label="Incorrect"
          score={(questionAnalytics.incorrect_students / questionAnalytics.total_students) * 100}
          color="#E33629"
          subLabel=""
          metricType="accuracy"
          totalPossible={100}
        />
        <p className="qa_students">
          {questionAnalytics.incorrect_students} Students
        </p>
      </div>

      {/* Unanswered */}
      <div className="qa_stat_column">
        <ScoreBar
          label="Unanswered"
          score={(questionAnalytics.unanswered_students / questionAnalytics.total_students) * 100}
          color="#80848C"
          subLabel=""
          metricType="accuracy"
          totalPossible={100}
        />
        <p className="qa_students">
          {questionAnalytics.unanswered_students} Students
        </p>
      </div>
    </div>

    {/* TIME ROW */}
    <div className="qa_time_row">
  <div className="qa_time_item">
    <p className="qa_time_title">Your Time</p>
    <p className="qa_time_value qa_time_blue">
      {formatTime(questionAnalytics.your_time)}
    </p>
  </div>

  <div className="qa_time_item">
    <p className="qa_time_title">Average Time</p>
    <p className="qa_time_value qa_time_black">
      {formatTime(questionAnalytics.average_time)}
    </p>
  </div>

  <div className="qa_time_item">
    <p className="qa_time_title">Topper Time</p>
    <p className="qa_time_value qa_time_green">
      {formatTime(questionAnalytics.topper_time)}
    </p>
  </div>
</div>


    <button className="qa_close_btn" onClick={closeAnalyticsModal}>
      Close
    </button>
  </div>
) : (
  <p>No Analytics Available</p>
)}

      </Modal>
    </div>
  );
}
